import React from "react";
import "../../../../../css/games/americanRoulette/title.css";
import american_roulette_timer from "../../../../../../assets/titles/indie/americanRouletteTimer.svg";

export default function Title(props) {
    return (
        <div className="fd text_center mobile-timer-title">
            {/* <img className='ht_80' src={american_roulette_timer} alt={american_roulette_timer}></img> */}
            <h1 className="Game_Title_american_timer">American Roulette Timer</h1>
        </div>
    )
}
